import React, {useEffect, useState} from 'react';
import Wrapper from "../component/Wrapper";
import Slider from "react-slick";
import Api from "../Api";
import _ from 'lodash'
import {Link} from "react-router-dom";
import plus from '../assets/img/icon/plus.png'
import ClientBlock from "../component/ClientBlock";
import Solution from "../component/Solution";
import Stories from "../component/Stories";
import InstallPbx from "../component/InstallPbx";
import appstore from "../assets/img/icon/apple.svg";
import playstore from "../assets/img/icon/android.svg";
import {buttons, homeD, lang, meta} from "../helpers/translate";
import {REACT_APP_API_URL} from '../config'
import Utils from "../helpers/Utils";
import Loader from "../component/Loader";
import img from "../assets/img/block/LogoHosted.svg";
import operators from "../assets/img/icon/operator.avif";
import {useParams} from "react-router";
import HelmetHeader from "../component/HelmetHeader";



function Home() {
    const [homeSlides, setHomeSlides] = useState([])
    const [service, setService] = useState([])
    const [serviceItems, setServiceItems] = useState([])
    const [feature, setFeature] = useState({})
    const params = useParams()

    const [operator, setOperator] = useState([])
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: dots => (
            <div
                style={{
                    borderRadius: "10px",
                    padding: "10px",
                }}
            >
                <ul className="carousel_banner_dot" style={{margin: "0px"}}> {dots} </ul>
            </div>
        ),
        customPaging: i => (
            <div
                style={{
                    width: "15px",
                    height: "15px",
                    overflow: 'hidden'
                }}
            />
        )
    };

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const [loader, setLoader] = useState(true)
    const heroSettings = {
        dots: true,
        infinite: homeSlides.length > 1,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5500,
        pauseOnHover: false,
        pauseOnFocus: false,
        appendDots: dots => (
            <div>
                <ul className="carousel_banner_dot" style={{margin: "0px"}}>{dots}</ul>
            </div>
        ),
        customPaging: () => (
            <div
                style={{
                    width: "12px",
                    height: "12px",
                    overflow: 'hidden'
                }}
            />
        ),
    }
    useEffect(() => {
        (async () => {
            try {
                const {data} = await Api.get(lang[params?.lang || 'en'] || 1)
                const slides = (Array.isArray(data.home) ? data.home : (data.home ? [data.home] : []))
                    .filter((slide) => slide && (slide.image || slide?.home_translate?.length))
                setHomeSlides(slides)
                const feat = await Api.getFeature(lang[params?.lang || 'en'] || 1)
                setFeature(feat.data.updatedServiceTranslate.home_translate[0])
                const service = await Api.getService(lang[params?.lang || 'en'] || 1)
                if (slides.length && slides[0]?.image) {
                    const imageUrl = REACT_APP_API_URL + slides[0].image;

                    const link = document.createElement('link');
                    link.rel = 'preload';
                    link.href = imageUrl;
                    link.as = 'image';
                    document.head.appendChild(link);
                }
                setServiceItems(service.data?.service || [])
                const partner = await Api.getPartner(lang[params?.lang || 'en'] || 1)
                setOperator(partner.data)

                setLoader(false)
            } catch (e) {

            }
        })()
    }, [params?.lang, REACT_APP_API_URL])

    useEffect(() => {
        const chunks = [];
        const chunkSize = windowWidth > 1024 || windowWidth <= 560 ? 4 : 8;

        for (let i = 0; i < serviceItems.length; i += chunkSize) {
            chunks.push(serviceItems.slice(i, i + chunkSize));
        }

        setService(chunks);
    }, [serviceItems, windowWidth]);
    if (loader) {
        return (
            <Loader />
        );
    } else {
        return (
            <Wrapper>
                <HelmetHeader type="home"/>
                <Slider className="home_hero_slider" key={`hero-${homeSlides.length}`} {...heroSettings}>
                    {(homeSlides.length ? homeSlides : [{}]).map((slide, index) => {
                        const bannerStyle = slide?.image && windowWidth > 1024
                            ? {
                                backgroundImage: `url(${REACT_APP_API_URL}${slide.image})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                                backgroundPosition: 'right center',
                            }
                            : {};

                        return (<div key={slide?.id || index}>
                            <div className="main_container top_banner"
                                 style={bannerStyle}>
                                <div className="top_banner_content">
                                    <p className="h3">{slide?.home_translate?.[0]?.title || ''}</p>
                                    <div className="top_banner_p"
                                         dangerouslySetInnerHTML={{__html: slide?.home_translate?.[0]?.desc || ''}}/>
                                    <Link to={windowWidth > 786 ? '#register' : `/${Utils.lang()}/register`} className="register_btn">
                                        <img src={plus} alt=''/>
                                        {buttons.reg[+lang[params?.lang || 'en'] || 3]}
                                    </Link>
                                </div>
                                <div className="top_banner_image">
                                    <img
                                        style={
                                                windowWidth <= 390 && index === 2 && +lang[params?.lang || 'en'] === 1
                                                    ? {objectPosition: '-535px center', objectFit: 'cover'}
                                                    : windowWidth <= 390 && index === 2 && +lang[params?.lang || 'en'] === 2
                                                    ? {objectPosition: '-540px center', objectFit: 'cover'}
                                                    : windowWidth <= 390 && +lang[params?.lang || 'en'] === 2
                                                    ? {objectPosition: '-410px center', objectFit: 'cover'}
                                                    : windowWidth <= 390 && +lang[params?.lang || 'en'] === 3
                                                    ? {objectPosition: '-538px center', objectFit: 'cover'}
                                                    : windowWidth <= 390 && index === 2
                                                    ? {objectPosition: '-563px center', objectFit: 'cover'}
                                                 
                                                    : windowWidth <= 430 && +lang[params?.lang || 'en'] === 2 && index === 2
                                                    ? {objectPosition: '-456px center', objectFit: 'cover'}:
                                                    windowWidth <= 430 && +lang[params?.lang || 'en'] === 2 && index === 2
                                                    ? {objectPosition: '-446px center', objectFit: 'cover'}:
                                                    windowWidth <= 430 && +lang[params?.lang || 'en'] === 3 && index === 2
                                                    ? {objectPosition: '-450px center', objectFit: 'cover'}
                                                    : windowWidth <= 450 && +lang[params?.lang || 'en'] === 3
                                                    ? {objectPosition: '-400px center', objectFit: 'cover'}
                                                    : windowWidth <= 560
                                                        ? {objectPosition: '-346px center', objectFit: 'cover'}
                                                        : null}
                                        className='top_banner_img' alt=''
                                        src={slide?.image ? REACT_APP_API_URL + slide.image : ''}/>
                                </div>
                            </div>
                        </div>)
                    })}
                </Slider>

                <ClientBlock isHome={true}/>
                <h1 className="ats_h1">{homeD.title[+lang[params?.lang || 'en']]}</h1>
                {windowWidth <= 435 ?
                    <div className="solution_install">
                        <InstallPbx home={true}/>
                        <Solution/>

                    </div>
                    : null
                }
                {windowWidth > 435 ?
                    <Solution isHome={true}/>
                    : null
                }
                <div className="carousel_banner">
                    <div className="carousel_banner_1">
                        <div style={{paddingBottom: 0}}>
                            <h2>{feature?.title}</h2>
                            <p dangerouslySetInnerHTML={{__html: feature?.desc}}/>
                        </div>
                        <Slider {...settings}>
                            {service?.map((s, i) => (
                                <div key={i}>

                                    <div className="carousel_banner_service">
                                        {s.map(el => (
                                            <div key={el.icon}>
                                                <img loading="lazy" src={REACT_APP_API_URL + el.icon} alt=''/>
                                                <div className="text">
                                                    <h3 className="services_h3">
                                                        <Link style={{color:'black'}} to={`/${Utils.lang()}/services${el?.link}`}>{el.new_service_translate[0].title}</Link>
                                                    </h3>
                                                    <p>
                                                        {el.new_service_translate[0].descShort}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            ))}

                        </Slider>
                    </div>
                    {windowWidth > 1024 ? <Stories/> : null}
                </div>
                {windowWidth <= 1024 ?
                    <div className="carousel_banner resized">
                        <Stories isHome={windowWidth > 550}/>
                        <div className="main_container service_host_block">
                            <div className="operator">
                                <h3>{operator?.partner?.home_translate[0]?.title}</h3>
                                <figure className="d-flex align-items-center justify-content-center">
                                    <img loading="lazy" src={operators} alt=''/>
                                </figure>
                                <p>{operator?.partner?.home_translate[0]?.desc}</p>
                            </div>
                            {windowWidth > 560 ? <InstallPbx home={true}/> : null}
                        </div>
                    </div> : null}
                {windowWidth > 1024 ?
                    <div className="main_container service_host_block">
                        <div className="operator">
                            <h2>{operator?.partner?.home_translate[0]?.title}</h2>
                            <div>{operator?.partnerImages?.map(p => (
                                <figure key={p.path}><img loading="lazy" src={REACT_APP_API_URL + p.path} alt=''/></figure>
                            ))}</div>
                            <p>{operator?.partner?.home_translate[0]?.desc}</p>
                        </div>
                        <InstallPbx home={true}/>
                    </div> : null}
                {windowWidth <= 560 ?
                    <div className="download_block">
                        <div>
                            <h3>
                                {homeD.download_wrapper[lang[params?.lang || 'en']]}

                            </h3>
                            <span>
                            {homeD.download_desc[lang[params?.lang || 'en']]}
                        </span>
                        </div>
                        <div style={{marginLeft: 20, margin: 30}}
                             className="d-flex align-items-baseline justify-content-center">
                            <a target="_blank" href="https://apps.apple.com/am/app/ipats-client/id6468366668"
                               style={{display: 'inline-block', margin: '0 20px'}}>
                                <img src={appstore} alt="Download Android"/>
                            </a>
                            <a target="_blank"
                               href="https://play.google.com/store/apps/details?id=am.ats.ipats_client&pcampaignid=web_share"
                               style={{display: 'inline-block', margin: '0 20px'}}>
                                <img src={playstore} alt="Download IOS"/>
                            </a>
                        </div>
                    </div> : null}
            </Wrapper>
        );
    }

}

export default Home;
